import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import Contact from "../../components/Contact/Contact";
import ServicesSection from "../../components/ServicesSection/ServicesSection";

export default function PropertyManagement() {
  // Data for AlternatingImageText sections
  const customSections = [
    {
      title: "Commercial Asset Management",
      description: `Working closely in line with our clients’, we provide a dedicated service to help manage the use of space to optimise business premises.  We provide strategic advise to clients, to help them unlock value and potential from their commercial property in Liberia. Together with our clients’ we develop tailor-made strategies to maximise commercial income as well as focus on value-add opportunities.`,
      imageSrc: "/commercial.jpg",
      imageAlt: "Project audit analysis and reporting"
    },
    {
      title: "Our Key Responsibilities",
      bullets: [
        "Tenant Management – screening potential tenants, handling lease agreements, addressing tenant issues​",
        "Maintenance and Repairs – coordinating routine inspections, managing maintenance issues and ensuring at all times the property is in good condition",
        "Financial Management – collection of rent, managing of operating expenses e.g. maintenance and repair costs and providing financial status reports",
        "Legal Compliance – ensuring the property is compliant with and adheres to all local statutory regulations​",
      ],
      imageSrc: "/property.jpg",
      imageAlt: "Project audit analysis and reporting"
    },
  ];

  return (
    <>
      <HeroAlternative 
        title="Property Management Services"
        description="Simply put, we provide total oversight and administration of real estate properties, ensuring they are well maintained, tenants are satisfied, and property owners maximise their returns."
        imageSrc="/real_estate.jpg"
        ctaLink="/contact"
      />
      
      <AlternatingImageText 
        sections={customSections}
        backgroundColor="light"
      />
      
      <Contact 
        title="Ready to Launch Your Project with Confidence?"
        subtitle="Let's discuss how we can bring clarity and precision to your next initiative. Get a tailored plan for your success."
        ctaText="Schedule a Strategy Call"
      />
    </>
  );
}